import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTable, MatTableModule } from '@angular/material/table';

export interface ValidationMessage {
  stepName: string;
  stepType: "xsd" | "schematron" | "model";
  severity: "warning" | "error";
  message: string;
  code: string | null;
  location: string;
}

@Component({
    selector: 'app-validation-result-dialog',
    templateUrl: './validation-result-dialog.component.html',
    styleUrls: ['./validation-result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ValidationResultDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ValidationResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public validationError: ValidationMessage[],
  ) {
  }
}

